import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { exchangeSession } from "@/lib/auth";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/owner/login");
      return;
    }
    exchangeSession(sessionId)
      .then((user) => {
        window.history.replaceState({}, document.title, "/owner");
        navigate("/owner", { state: { user } });
      })
      .catch((e) => {
        setError(e?.response?.data?.detail || "Sign-in failed. Please try again.");
      });
  }, []);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6" data-testid="auth-callback">
      {error ? (
        <div className="max-w-md text-center">
          <p className="font-display text-3xl text-foreground">Access denied</p>
          <p className="mt-3 text-muted-foreground font-light">{error}</p>
          <a href="/owner/login" className="mt-6 inline-block rounded-full bg-primary px-7 py-3.5 text-sm text-primary-foreground">
            Try again
          </a>
        </div>
      ) : (
        <div className="flex items-center gap-3 text-muted-foreground">
          <Loader2 className="h-5 w-5 animate-spin" /> Signing you in...
        </div>
      )}
    </div>
  );
}
